var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_2948)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0923 12.8561C15.9447 13.9653 13.7038 15.1263 11.9731 16.0247L5.90391 12.8561C8.10148 16.0312 9.93224 18.6744 11.9731 21.5998C14.0173 18.6809 16.2749 15.4604 18.0923 12.8561ZM17.8589 11.9804L11.9664 8.9221L6.15067 11.9577L11.9631 15.0193L17.8589 11.9804ZM11.9731 7.94266L18.0923 11.0756L11.9998 2.40002L5.90391 11.095L11.9731 7.94266Z",
    fill: "#657ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8589 11.9805L11.9664 8.92212L6.15071 11.9578L11.9631 15.0193L17.8589 11.9805Z",
    fill: "#9C68AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9731 7.94266L18.0923 11.0756L11.9998 2.40002L5.90391 11.095L11.9731 7.94266Z",
    fill: "#F48975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9733 7.9429L12 2.40027L5.90415 11.0953L11.9733 7.9429Z",
    fill: "#F8EC66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15082 11.958L11.9666 8.92236L11.9632 15.0196L6.15082 11.958Z",
    fill: "#50BA78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9734 16.0249L5.90421 12.8563C8.10179 16.0314 11.9734 21.6 11.9734 21.6V16.0249Z",
    fill: "#10AED3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_2948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeth);
export default __webpack_public_path__ + "static/media/beth.7301396105da4ef5ae29c88e64580b0d.svg";
export { ForwardRef as ReactComponent };